import { starknetERC20Abi, starknetMulticallAbi } from '../../../abi'
import { Address } from '../../../types'
import { Contract, ProviderInterface, selector } from 'starknet'
import { BigNumber } from '@ethersproject/bignumber'
import { bn } from '../../../utils/number'

const selectorBalanceOf = selector.getSelectorFromName('balanceOf')

export function buildStarkBalanceOfCallData(
  accountAddress: Address,
  erc20Addresses: Address[],
): StarknetMulticallData[] {
  return erc20Addresses.map((erc20Address) => {
    const tokenContract = new Contract(starknetERC20Abi, erc20Address)
    const tx = tokenContract.populate('balanceOf', [accountAddress])

    return {
      address: erc20Address,
      selector: selectorBalanceOf,
      calldata: tx.calldata as string[],
    }
  })
}

export interface StarknetMulticallData {
  address: string // erc20 address, e.g. "0x..."
  selector: string // selector, e.g. "0x..."
  calldata: string[] // calldata, e.g. ["0x..."]
}
export async function sendStarkMulticall(
  provider: ProviderInterface,
  multicallAddress: Address,
  calls: StarknetMulticallData[],
): Promise<BigNumber[]> {
  const multicallContract = new Contract(starknetMulticallAbi, multicallAddress)

  multicallContract.connect(provider)

  const returnData = await multicallContract.multiStaticCall(calls)

  return returnData.map(
    ({ success, returnData }: { success: boolean; returnData: [bigint] }) => {
      return success ? bn(returnData[0]) : bn(0)
    },
  )
}
